interface V3IconCertificatesProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconCertificates = ({ stroke = "#2E77FF", strokeWidth = "1.5", ...rest }: V3IconCertificatesProps) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M8 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    <path d="m8.001 10.004 2.267 3.926 1.065-2.155 2.4.155-2.268-3.926M4.535 8.004 2.268 11.93l2.399-.155 1.065 2.155 2.267-3.926" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
</svg>

